import LandmarksAPI from '../api/landmarksid';
import { delay } from 'redux-saga'
import {all, call, takeEvery, put} from 'redux-saga/effects'
import {SAGA_AUTH_SIGN_IN} from './actions';

import {setError, resetErrors} from '../errors/actions';

import createHistory from 'history/createHashHistory'

const history = createHistory();

function *authSignIn(action){
  const results = yield call(LandmarksAPI.signIn, action.payload.credentials);

  if (results.error === null && results.json && results.json.statusCode === 200){
      localStorage.setItem('token', results.json.body.token);
      localStorage.setItem('admin', results.json.body.admin);

      if (!results.json.body.admin) {
          history.push('/loadNextJob');
      } else {
        history.push('/apps');
      }
  }else{
      yield put(setError(results.message));
      yield delay(4000);
      yield put(resetErrors());
  }
}

export default function* appsSaga(){
	yield all([
		takeEvery(SAGA_AUTH_SIGN_IN, authSignIn),
	]);
}


// WEBPACK FOOTER //
// ./src/auth/sagas.js